<div class="policy-category disabled">

  <div class="policy-item">
    <i class="policy-number">1</i>
    <div class="default-text large" [innerHTML]="textCopy.fillTableText"></div>
    <div class="default-text" [innerHTML]="textCopy.driverReasonsText"></div>

    <br />
    <div class="default-text" [innerHTML]="textCopy.proofTypesTitle"></div>
    <div class="question-block" *ngFor="let document of proofDocuments">
      <div class="question-label checkbox" (click)="onSelectProofDocument(document)"
           [ngClass]="{'selected': document.value === 'y'}">
        <i class="checkbox-placeholder"></i>
        <span [innerHTML]="document.text"></span>
      </div>
    </div>

  </div>

  <br />
  <div class="submit-layer">
    <input aria-label=""  type="submit" class="app-submit" value="Save"
           (click)="submitPolicyCategory()" />
  </div>

</div>
